import { formatInstant } from '../lib/time'

// A device's Emporia Cloud connection (online / offline / unknown), as derived by
// the API from its synced cloud blob. `unknown` = no recent reading to trust.
const STYLES = {
  online: 'badge-success',
  offline: 'badge-error badge-outline',
  unknown: 'badge-ghost',
}

export function connectionTitle(device) {
  const state = device.connection ?? 'unknown'
  if (state === 'unknown') {
    return device.cloud_synced_at
      ? `No recent cloud reading (last synced ${formatInstant(device.cloud_synced_at)})`
      : 'Never synced from Emporia Cloud'
  }
  const since = device.connected_changed_at
    ? ` since ${formatInstant(device.connected_changed_at)}`
    : ''
  return `${state === 'online' ? 'Online' : 'Offline'}${since}`
}

export default function ConnectionBadge({ device, size = 'sm' }) {
  const state = device.connection ?? 'unknown'
  return (
    <span
      className={`badge badge-${size} whitespace-nowrap ${STYLES[state] ?? STYLES.unknown}`}
      title={connectionTitle(device)}
    >
      {state}
    </span>
  )
}
